import React, { useEffect, useState } from 'react';
import { useObservableState } from 'observable-hooks';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';
import Form from '../../../components/form';
import Readonly from '../../../components/form/elements/readonly';
import Group from '../../../components/form/elements/group';
import Text from '../../../components/form/elements/text';
import Checkbox from '../../../components/form/elements/checkbox';
import Link from '../../../components/form/elements/link';
import { FARM_USERS_EDIT, FARM_USERS_INDEX } from '../../../router/routes';
import { FarmUser } from '../../../interfaces/farm-user';
import Abilities, { AbilityGroup } from './abilities';
import TextArea from '../../../components/form/elements/text-area';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

export default function FarmViewUser() {
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { selectedFarm } = useSelector((state: RootState) => ({
    selectedFarm: state.global.farm,
  }));
  const { t } = useTranslation();
  const { farmUserService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState(() => [
    Link(route(FARM_USERS_EDIT, { farmId, id }), 'edit', true),
  ]);
  const [user] = useObservableState<FarmUser>(
    () => farmUserService.show(farmId, id),
    null
  );
  const [abilities] = useObservableState<AbilityGroup[]>(
    () => farmUserService.abilities(farmId),
    null
  );

  const [values, setValues] = useState({});
  useEffect(() => {
    setValues((v) => ({ ...v, farm_name: selectedFarm.name, ...user }));
  }, [setValues, selectedFarm, user]);

  useEffect(() => {
    if (user !== null && abilities != null) {
      setBodyElements([
        Readonly([
          Group([
            Text('farm_name', 'pages.farm.users.farm_name'),
            Text('name', 'pages.farm.users.name'),
            Text('email', 'pages.farm.users.email'),
            Checkbox('owner', 'pages.farm.users.owner'),
            Checkbox('main_user', 'pages.farm.users.main_user'),
            Checkbox('blocked', 'pages.farm.users.blocked'),
            TextArea('comment', 'pages.farm.users.comment'),
            ...(user.owner || user.main_user
              ? []
              : [
                  Abilities(
                    abilities,
                    Object.fromEntries(
                      user.abilities.map((value) => [value.id, true])
                    )
                  ),
                ]),
          ]),
        ]),
      ]);
    }
  }, [user, abilities, farmUserService, setBodyElements, setFooterElements, t]);

  return (
    <Form
      mode={'view'}
      title={user ? user.name : t('pages.farm.users.view-user')}
      backTo={route(FARM_USERS_INDEX, { farmId })}
      body={bodyElements}
      footer={footerElements}
      values={values}
      submit={null}
      schema={null}
      noticeAccessor="ViewForm"
    />
  );
}
